import { useContext } from 'react';
import './CheckBox.css';
import { SlidesContext } from '../contexts/SlidesContext';
import ReviewFormattedMessage from './ReviewFormattedMessage';

export default function CheckBox ({ label, value, index, inputKey }) {
  const { updateValues } = useContext(SlidesContext);
  
  const handleInputChange = (event) => {
    console.log(event.target.checked)
    const target = event.target;
    const nvalue = target.checked;
    updateValues(index, inputKey, nvalue);
  }
  return(
  <div className={index < 70 ? "CheckBox-button" : "CheckBox-button checkbox-narrow"}>
      <label>
          <input type="checkbox" checked={value} onChange={handleInputChange}/>           
          <span className="CBInput"><ReviewFormattedMessage descriptor={label}/></span>
      </label>
    </div>
  )
}
